export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_API,
  userBaseUrl: "/bo",
  filePath: "",
  //Configurations
  loginUrl() {
    return this.baseUrl + "/customer/login";
  },
  registerUrl() {
    return this.baseUrl + "/customer/register";
  },
  customerUrl() {
    return this.baseUrl + "/customer/details";
  },
  merchantUrl() {
    return this.baseUrl + "/merchant/list";
  },
  detailsUrl() {
    return this.baseUrl + "/merchant/details";
  },
  bannerUrl() {
    return this.baseUrl + "/merchant/banner";
  },
  menuUrl() {
    return this.baseUrl + "/merchant/menu";
  },
  itemDetailsUrl() {
    return this.baseUrl + "/menu/itemdetails";
  },
  availableTableUrl() {
    return this.baseUrl + "/table/availabletable";
  },
  orderUrl() {
    return this.baseUrl + "/customer/order";
  },
  getOrderUrl() {
    return this.baseUrl + "/customer/orderlist";
  },
  paymentUrl() {
    return this.baseUrl + "/customer/payment";
  },
  promoUrl() {
    return this.baseUrl + "/promo/list";
  },
  applyPromoUrl() {
    return this.baseUrl + "/promo/apply";
  },
  redeemPromoUrl() {
    // return this.baseUrl + "/promo/redeem";
    return this.baseUrl + "/promo/customer";
  },
  typeUrl() {
    return this.baseUrl + "/business/type";
  },
  businessUrl() {
    return this.baseUrl + "/business/list";
  },
  businessBannerUrl() {
    return this.baseUrl + "/business/banner";
  },
  reviewUrl() {
    return this.baseUrl + "/review";
  },
  reviewListUrl() {
    return this.baseUrl + "/review/list";
  },
  reviewCustomerUrl() {
    return this.baseUrl + "/review/customer";
  },
  locationUrl() {
    return this.baseUrl + "/location/customer";
  },
  promotionUrl() {
    return this.baseUrl + "/promo/list";
  },
  promotionDetailUrl() {
    return this.baseUrl + "/promo/detail";
  },
  promotionHistoryUrl() {
    return this.baseUrl + "/promo/own";
  },
  /*
    paymentRedirectUrl() is used for testing purposes in localhost. This is 
      because ipay88 does not allow access from localhost, hence will have to 
      pass the data directly into the function to be inserted into the ipay88 table.
    */
  paymentRedirectUrl() {
    return this.baseUrl + "/payment/redirect";
  },
  livestreamDetailsUrl() {
    return this.baseUrl + "/livestream/details";
  },
  livestreamUpdateUrl() {
    return this.baseUrl + "/livestream/update";
  },
  livestreamCancelUrl() {
    return this.baseUrl + "/livestream/cancel";
  },
  //APIs for dine-in/take-away only
  dineInUrl() {
    return this.baseUrl + "/order/tableorder";
  },
  placeDineInUrl() {
    return this.baseUrl + "/order/placetableorder";
  },
  cancelDineInUrl() {
    return this.baseUrl + "/order/canceltableorder";
  }
};
